import { batchActions } from 'redux-batched-actions';

/**
 * @param {string} type
 * @param {(payload: any) => import('redux').AnyAction[]} [actions]
 */
export default (type, actions = () => []) => {
  const actionCreator = (payload) => {
    const action = batchActions([
      { type, payload },
      ...actions(payload)
    ], type);
    action.meta.payload = payload;
    return action;
  };

  actionCreator.toString = () => type;
  return actionCreator;
};